import { Typography, Flex } from "antd";
import { TitleCardsList } from "Components/SelectableCard/Title";

const tuitionFeeOptions = [
  {
    title: "In-state",
    value: "In State",
  },
  {
    title: "Out-of-state",
    value: "Out of State",
  },
];

export const TuitionFeePreference = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start" style={{}}>
      <Title style={{ fontSize: "18px", textAlign: "left" }}>
        Tuition preference
      </Title>
      <Flex wrap>
        <TitleCardsList
          options={tuitionFeeOptions}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
      </Flex>
    </Flex>
  );
};
